import { useEffect, useState } from "react";
import { Box, useTheme, Divider, Table, TableBody, TableSortLabel, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";

import CallAlertBar from "../../../Layout/Alertbar";


import Header from "../../../Layout/Header";
import dayjs from "dayjs";
import LeaveRequestForm from "./LeaveRequestForm";
import { tokens } from "../../../theme/theme";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";


const LeaveApprovalDashboard = ({ handleBackWinderMachineEntry }) => {
    const [leaveRequests, setLeaveRequests] = useState([]);
    const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
    const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
    const [parentRollMessageValue, setParentRollMessageValue] = useState('Welcome to Paper Roll Booking! ');
    const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');

    const [editLeaveRequest, setEditLeaveRequest] = useState(false);
    const [viewleaveRequestData, setViewLeaveRequestData] = useState(true);

    const [SelectedEmployeeleaveRequests, setSelectedEmployeeleaveRequests] = useState([]);

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    useEffect(() => {
        fetchPendingRequests();
    }, []);

    const fetchPendingRequests = async () => {
        const companyid = localStorage.getItem('companyid');

        callApi(API_ENDPOINTS.EMPLOYEE_GetEmployeeLeaveRequestList, 'POST', { 'Content-Type': 'application/json' }, companyid)
            .then(data => {
                if (data?.length) {
                    setLeaveRequests(data);
                }
                else { setLeaveRequests([]); }
            })
            .catch(error => alert(error.message));
    };



    const getStatusStyle = (status) => {
        switch (status) {
            case "Approved":
                return { color: "#90EE90", };
            case "Rejected":
                return { color: "#ff6666", };
            case "Pending":
                return { color: "#87CEEB", }; // Change to your preferred color
            default:
                return {};
        }
    };


    const [order, setOrder] = useState("asc");
    const [orderBy, setOrderBy] = useState("employee_fullname");

    const handleSort = (property) => {
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };



    // Define a custom order for statuses
    const statusOrder = {
        Pending: 1,
        Approved: 2,
        Rejected: 3,
    };

    const sortedLeaveRequests = [...leaveRequests].sort((a, b) => {
        const aValue =
            orderBy === "approval_status"
                ? statusOrder[a[orderBy]] || 999 // Default high order for unknown statuses
                : a[orderBy];
        const bValue =
            orderBy === "approval_status"
                ? statusOrder[b[orderBy]] || 999
                : b[orderBy];

        if (order === "asc") {
            return aValue < bValue ? -1 : 1;
        } else {
            return aValue > bValue ? -1 : 1;
        }
    });

    const handleEditLeaverRequest = (request) => {
        setEditLeaveRequest(true);
        setViewLeaveRequestData(false);

        setSelectedEmployeeleaveRequests(request);

    }


    const handleViewLeaverRequest = () => {
        setEditLeaveRequest(false);
        setViewLeaveRequestData(true);

        fetchPendingRequests();
    }
    // const calculateLeaveDuration = (startDate, endDate) => {
    //     if (!startDate || !endDate) {
    //         return "Invalid dates"; // Handle missing dates
    //     }

    //     const start = dayjs(startDate);
    //     const end = dayjs(endDate);

    //     if (!start.isValid() || !end.isValid() || end.isBefore(start)) {
    //         return "Invalid dates"; // Handle invalid or incorrect date range
    //     }

    //     const duration = end.diff(start, 'day') + 1; // Include the start date

    //     // Return the formatted string
    //     return `${duration} ${duration === 1 ? "day" : "days"}`;
    // };

    const calculateLeaveDuration = (start, end, isHalfDay, halfDayType, isHourly = false, durationInHours = 0) => {
        if (!start || (!end && !isHalfDay && !isHourly)) return "";

        if (isHourly) {
            return `${durationInHours} Hour(s)`;
        }

        if (isHalfDay) {
            return `0.5 Day (${halfDayType || "Select Half"})`;
        }

        const startDate = new Date(start);
        const endDateVal = new Date(end);

        // Normalize to date only (ignore time)
        startDate.setHours(0, 0, 0, 0);
        endDateVal.setHours(0, 0, 0, 0);

        const timeDiff = endDateVal.getTime() - startDate.getTime();
        const dayDiff = Math.floor(timeDiff / (1000 * 3600 * 24)) + 1;

        return `${dayDiff} Day(s)`;
    };


    return (

        <>
            {viewleaveRequestData && (

                <Box >


                    <Header title={'Pending Leave Requests'} subtitle='' callback={handleBackWinderMachineEntry} />
                    <Divider />

                    <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
                        setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
                        setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />

                    <Box
                        gridColumn="span 9"
                        gridRow={"span 2"}
                        alignItems="center"
                        justifyContent="center"
                        padding={1}
                        sx={{
                            maxHeight: {
                                xs: '72vh', // Extra small devices (phones)
                                sm: '72vh', // Small devices (tablets)
                                md: '72vh', // Medium devices (small laptops)
                                lg: '72vh', // Large devices (desktops)
                                xl: '89vh', // Extra large devices (large desktops)
                            },
                            overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                            '&::-webkit-scrollbar': {
                                width: '8px',
                            },
                            '&::-webkit-scrollbar-track': {
                                background: colors.primary[400],
                                borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: colors.blueAccent[600],
                                borderRadius: '10px',
                                '&:hover': {
                                    background: colors.blueAccent[800],
                                },
                            },
                            '&::-webkit-scrollbar-corner': {
                                background: colors.primary[700],
                            },


                            "& .MuiTable-root": {
                                border: "none",
                                size: "small",
                            },
                            "& .MuiTableCell-root": {
                                borderBottom: "none",
                                // fontWeight: "bold",
                                border: "1px solid ",
                                borderColor: `${colors.primary[400]} !important`,
                            },
                            "& .name-column--cell": {
                                color: colors.greenAccent[300],
                            },
                            "& .MuiTableHead-root": {
                                // backgroundColor: colors.blueAccent[700],
                                borderBottom: "none",
                            },
                            "& .MuiTableBody-root": {
                                overflowY: "auto",
                            },
                            "& .MuiCheckbox-root": {
                                color: `${colors.blueAccent[200]} !important`,
                                size: "small",
                            },
                            "& .MuiTableFooter-root": {
                                borderTop: "none",
                                backgroundColor: colors.blueAccent[700],
                                height: "10px",
                            },
                            "& .MuiButton-text": {
                                color: `${colors.grey[100]} !important`,
                            },
                        }}>

                        <TableContainer>
                            <Table size="small" stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            <TableSortLabel
                                                active={orderBy === "employee_fullname"}
                                                direction={orderBy === "employee_fullname" ? order : "asc"}
                                                onClick={() => handleSort("employee_fullname")}
                                            >
                                                Employee Name
                                            </TableSortLabel>
                                        </TableCell>

                                        <TableCell>
                                            <TableSortLabel
                                                active={orderBy === "designation"}
                                                direction={orderBy === "designation" ? order : "asc"}
                                                onClick={() => handleSort("designation")}
                                            >
                                                Designation
                                            </TableSortLabel>
                                        </TableCell>

                                        <TableCell>
                                            <TableSortLabel
                                                active={orderBy === "leave_type"}
                                                direction={orderBy === "leave_type" ? order : "asc"}
                                                onClick={() => handleSort("leave_type")}
                                            >
                                                Leave Type
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell>
                                            <TableSortLabel
                                                active={orderBy === "leave_request_date"}
                                                direction={orderBy === "leave_request_date" ? order : "asc"}
                                                onClick={() => handleSort("leave_request_date")}
                                            >
                                                Leave Request Date
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell>
                                            <TableSortLabel
                                                active={orderBy === "leave_start_date"}
                                                direction={orderBy === "leave_start_date" ? order : "asc"}
                                                onClick={() => handleSort("leave_start_date")}
                                            >
                                                Start Date
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell>
                                            <TableSortLabel
                                                active={orderBy === "leave_end_date"}
                                                direction={orderBy === "leave_end_date" ? order : "asc"}
                                                onClick={() => handleSort("leave_end_date")}
                                            >
                                                End Date
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell>Duration</TableCell>
                                        <TableCell>Reason</TableCell>
                                        <TableCell>
                                            <TableSortLabel
                                                active={orderBy === "approval_status"}
                                                direction={orderBy === "approval_status" ? order : "asc"}
                                                onClick={() => handleSort("approval_status")}
                                            >
                                                Status
                                            </TableSortLabel>
                                        </TableCell>
                                        {/* <TableCell>Actions</TableCell> */}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {sortedLeaveRequests.map((request) => (
                                        <TableRow key={request.id}>
                                            <TableCell> <span
                                                style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                onClick={() => handleEditLeaverRequest(request)}
                                            >
                                                {request.employee_fullname}
                                            </span></TableCell>
                                            <TableCell>{request.designation}</TableCell>
                                            <TableCell>{request.leave_type}</TableCell>
                                            <TableCell>
                                                {dayjs(request.leave_request_date).format("DD-MMM-YYYY")}
                                            </TableCell>
                                            <TableCell>
                                                {dayjs(request.leave_start_date).format("DD-MMM-YYYY")}
                                            </TableCell>
                                            <TableCell>
                                                {dayjs(request.leave_end_date).format("DD-MMM-YYYY")}
                                            </TableCell>
                                            <TableCell>
                                                {calculateLeaveDuration(request.leave_start_date, request.leave_end_date, request.is_half_day, request.half_day_type, request.is_hour_permission, request.number_of_hours)}
                                            </TableCell>

                                            <TableCell>{request.leave_reason}</TableCell>
                                            <TableCell style={getStatusStyle(request.approval_status)}>
                                                {request.approval_status}
                                            </TableCell>

                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Box>
            )}

            {editLeaveRequest && (

                <LeaveRequestForm handleBackWinderMachineEntry={handleViewLeaverRequest} SelectedEmployeeleaveRequests={SelectedEmployeeleaveRequests} />
            )}
        </>

    );
};

export default LeaveApprovalDashboard;
